import DashIcon from './DashIcon'
import Spark from './Spark'

interface DashStatCardProps {
  label: string
  value: string
  trend?: string
  trendDir?: 'up' | 'down'
  icon?: string
  accent?: 'dark' | 'green'
  spark?: number[]
  sparkColor?: string
}

export default function DashStatCard({
  label, value, trend, trendDir = 'up',
  icon, accent, spark, sparkColor,
}: DashStatCardProps) {
  return (
    <div className={`stat-card${accent === 'dark' ? ' is-dark' : ''}${accent === 'green' ? ' is-green' : ''}`}>
      <div className="sc-head">
        <div>
          <div className="sc-label">{label}</div>
          <div className="sc-value">{value}</div>
        </div>
        {icon && (
          <div className="sc-icon">
            <DashIcon name={icon} />
          </div>
        )}
      </div>
      <div className="sc-foot">
        {trend && (
          <span className={`sc-trend${trendDir === 'down' ? ' down' : ''}`}>
            <DashIcon name={trendDir === 'down' ? 'arrowDown' : 'arrowUp'} size={12} />
            {trend}
          </span>
        )}
        {spark && <Spark data={spark} color={sparkColor} />}
      </div>
    </div>
  )
}
